import { parseReferralSystemUid, ReferralSystem, ReferralSystemSchema } from '../../ReferralSystem/models/ReferralSystem'
import { getFinder, getInserter } from 'src/util/src/zod'

export const allReferralSystems: ReferralSystem[] = []

export const addReferralSystem = getInserter('ReferralSystem', ReferralSystemSchema, parseReferralSystemUid, allReferralSystems)

export const findReferralSystem = getFinder(parseReferralSystemUid, allReferralSystems)

export const Kuna = addReferralSystem({
  id: 'Kuna',
  referralUrlPattern: 'https://kuna.io?r={{code}}',
})

export const Binance = addReferralSystem({
  id: 'Binance',
  referralUrlPattern: 'https://accounts.binance.com/register?ref={{code}}',
})

// export const BestchangeRu = addReferralSystem({
//   id: 'BestchangeRu',
//   referralUrlPattern: 'https://bestchange.ru/',
// })
